import { useEffect } from "react"

export const usePasteListener = (onPaste) => {
    useEffect(() => {
        window.addEventListener('paste', onPaste);

        return () => window.removeEventListener('paste', onPaste);
    }, [onPaste]);
}